import React from "react"
import {Box, SvgIcon} from "@mui/material"

const DartHoneyWidget = ({widget}) => {
    const dartColor = "#062AB8"
    const onClick = () => widget.action && triggerAction(widget.action, widget)
    return (
        <Box sx={{width: "120px", height: "120px", maxWidth: "120px", maxHeight: "120px"}}>
            <SvgIcon
                htmlColor={dartColor}
                onClick={onClick}
                sx={{width: "100%", height: "100%", cursor: "pointer"}}
            >
                <svg
                    viewBox="10 10 111 119"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M61.809 11.9168L19.7053 26.6816C13.2926 
                    28.9304 9 34.9846 9 41.7802V96.2198C9 103.015 
                    13.2926 109.07 19.7053 111.318L61.809 
                    126.083C65.3408 127.322 69.1949 127.283 
                    72.7011 125.974L111.597 111.449C117.853 
                    109.113 122 103.137 122 96.4599V41.5401C122
                     34.8625 117.853 28.8871 111.597 26.5511L72.701
                      12.0263C69.1949 10.717 65.3408 10.6782 61.809
                       11.9168Z"
                        fill={dartColor}
                    />
                    <path
                        d="M65.9999 96.6668C80.7275 96.6668 92.6666 84.7278
                     92.6666 70.0002C92.6666 55.2726 80.7275 43.3335
                      65.9999 43.3335C51.2723 43.3335 39.3333 55.2726
                       39.3333 70.0002C39.3333 84.7278 51.2723 96.6668
                        65.9999 96.6668Z"
                        stroke="white"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M65.9999 86.0002C74.8365 86.0002 81.9999
                     78.8367 81.9999 70.0002C81.9999 61.1636
                      74.8365 54.0002 65.9999 54.0002C57.1634
                       54.0002 49.9999 61.1636 49.9999 70.0002C49.9999
                        78.8367 57.1634 86.0002 65.9999 86.0002Z"
                        stroke="white"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M65.9999 75.3335C68.9454 75.3335 71.3333 72.9457
                     71.3333 70.0002C71.3333 67.0546 68.9454 64.6668 
                     65.9999 64.6668C63.0544 64.6668 60.6666 67.0546 
                     60.6666 70.0002C60.6666 72.9457 63.0544 75.3335 
                     65.9999 75.3335Z"
                        stroke="white"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </SvgIcon>
        </Box>
    )
}

export default DartHoneyWidget
